export const styles = () => ({
  root: {
    position: 'fixed',
    height: 400,
    width: 350,
    bottom: 15,
    right: 15,
    display: 'none',
    zIndex: 4,
  },
  active: {
    display: 'block',
  },
});
